

export const getFlagUrl = (countryCode) => {
    if (countryCode === 'OTHER') {
        return null; // Will use emoji for "other"
    }
    return `https://flagcdn.com/w40/${countryCode.toLowerCase()}.png`;
};

export const countriesUnsorted = [
    { code: 'IL', name: 'ישראל', prefix: '972' },
    { code: 'US', name: 'ארצות הברית', prefix: '1' },
    { code: 'AF', name: 'אפגניסטן', prefix: '93' },
    { code: 'AL', name: 'אלבניה', prefix: '355' },
    { code: 'DZ', name: 'אלג\'יריה', prefix: '213' },
    { code: 'AD', name: 'אנדורה', prefix: '376' },
    { code: 'AO', name: 'אנגולה', prefix: '244' },
    { code: 'AG', name: 'אנטיגואה וברבודה', prefix: '1268' },
    { code: 'AR', name: 'ארגנטינה', prefix: '54' },
    { code: 'AM', name: 'ארמניה', prefix: '374' },
    { code: 'AU', name: 'אוסטרליה', prefix: '61' },
    { code: 'AT', name: 'אוסטריה', prefix: '43' },
    { code: 'AZ', name: 'אזרבייג\'ן', prefix: '994' },
    { code: 'BS', name: 'בהאמה', prefix: '1242' },
    { code: 'BH', name: 'בחריין', prefix: '973' },
    { code: 'BD', name: 'בנגלדש', prefix: '880' },
    { code: 'BB', name: 'ברבדוס', prefix: '1246' },
    { code: 'BY', name: 'בלארוס', prefix: '375' },
    { code: 'BE', name: 'בלגיה', prefix: '32' },
    { code: 'BZ', name: 'בליז', prefix: '501' },
    { code: 'BJ', name: 'בנין', prefix: '229' },
    { code: 'BT', name: 'בהוטן', prefix: '975' },
    { code: 'BO', name: 'בוליביה', prefix: '591' },
    { code: 'BA', name: 'בוסניה והרצגובינה', prefix: '387' },
    { code: 'BW', name: 'בוצואנה', prefix: '267' },
    { code: 'BR', name: 'ברזיל', prefix: '55' },
    { code: 'BN', name: 'ברוניי', prefix: '673' },
    { code: 'BG', name: 'בולגריה', prefix: '359' },
    { code: 'BF', name: 'בורקינה פאסו', prefix: '226' },
    { code: 'BI', name: 'בורונדי', prefix: '257' },
    { code: 'CV', name: 'כף ורדה', prefix: '238' },
    { code: 'KH', name: 'קמבודיה', prefix: '855' },
    { code: 'CM', name: 'קמרון', prefix: '237' },
    { code: 'CA', name: 'קנדה', prefix: '1' },
    { code: 'CF', name: 'הרפובליקה המרכז-אפריקאית', prefix: '236' },
    { code: 'TD', name: 'צ\'אד', prefix: '235' },
    { code: 'CL', name: 'צ\'ילה', prefix: '56' },
    { code: 'CN', name: 'סין', prefix: '86' },
    { code: 'CO', name: 'קולומביה', prefix: '57' },
    { code: 'KM', name: 'קומורו', prefix: '269' },
    { code: 'CG', name: 'קונגו', prefix: '242' },
    { code: 'CD', name: 'קונגו הדמוקרטית', prefix: '243' },
    { code: 'CR', name: 'קוסטה ריקה', prefix: '506' },
    { code: 'HR', name: 'קרואטיה', prefix: '385' },
    { code: 'CU', name: 'קובה', prefix: '53' },
    { code: 'CY', name: 'קפריסין', prefix: '357' },
    { code: 'CZ', name: 'צ\'כיה', prefix: '420' },
    { code: 'DK', name: 'דנמרק', prefix: '45' },
    { code: 'DJ', name: 'ג\'יבוטי', prefix: '253' },
    { code: 'DM', name: 'דומיניקה', prefix: '1767' },
    { code: 'DO', name: 'הרפובליקה הדומיניקנית', prefix: '1809' },
    { code: 'EC', name: 'אקוודור', prefix: '593' },
    { code: 'EG', name: 'מצרים', prefix: '20' },
    { code: 'SV', name: 'אל סלבדור', prefix: '503' },
    { code: 'GQ', name: 'גינאה המשוונית', prefix: '240' },
    { code: 'ER', name: 'אריתריאה', prefix: '291' },
    { code: 'EE', name: 'אסטוניה', prefix: '372' },
    { code: 'SZ', name: 'אסוואטיני', prefix: '268' },
    { code: 'ET', name: 'אתיופיה', prefix: '251' },
    { code: 'FJ', name: 'פיג\'י', prefix: '679' },
    { code: 'FI', name: 'פינלנד', prefix: '358' },
    { code: 'FR', name: 'צרפת', prefix: '33' },
    { code: 'GA', name: 'גבון', prefix: '241' },
    { code: 'GM', name: 'גמביה', prefix: '220' },
    { code: 'GE', name: 'גאורגיה', prefix: '995' },
    { code: 'DE', name: 'גרמניה', prefix: '49' },
    { code: 'GH', name: 'גאנה', prefix: '233' },
    { code: 'GR', name: 'יוון', prefix: '30' },
    { code: 'GD', name: 'גרנדה', prefix: '1473' },
    { code: 'GT', name: 'גואטמלה', prefix: '502' },
    { code: 'GN', name: 'גינאה', prefix: '224' },
    { code: 'GW', name: 'גינאה-ביסאו', prefix: '245' },
    { code: 'GY', name: 'גיאנה', prefix: '592' },
    { code: 'HT', name: 'האיטי', prefix: '509' },
    { code: 'HN', name: 'הונדורס', prefix: '504' },
    { code: 'HK', name: 'הונג קונג', prefix: '852' },
    { code: 'HU', name: 'הונגריה', prefix: '36' },
    { code: 'IS', name: 'איסלנד', prefix: '354' },
    { code: 'IN', name: 'הודו', prefix: '91' },
    { code: 'ID', name: 'אינדונזיה', prefix: '62' },
    { code: 'IR', name: 'איראן', prefix: '98' },
    { code: 'IQ', name: 'עיראק', prefix: '964' },
    { code: 'IE', name: 'אירלנד', prefix: '353' },
    { code: 'IT', name: 'איטליה', prefix: '39' },
    { code: 'CI', name: 'חוף השנהב', prefix: '225' },
    { code: 'JM', name: 'ג\'מייקה', prefix: '1876' },
    { code: 'JP', name: 'יפן', prefix: '81' },
    { code: 'JO', name: 'ירדן', prefix: '962' },
    { code: 'KZ', name: 'קזחסטן', prefix: '7' },
    { code: 'KE', name: 'קניה', prefix: '254' },
    { code: 'KI', name: 'קיריבטי', prefix: '686' },
    { code: 'KP', name: 'קוריאה הצפונית', prefix: '850' },
    { code: 'KR', name: 'קוריאה הדרומית', prefix: '82' },
    { code: 'KW', name: 'כווית', prefix: '965' },
    { code: 'KG', name: 'קירגיזסטן', prefix: '996' },
    { code: 'LA', name: 'לאוס', prefix: '856' },
    { code: 'LV', name: 'לטביה', prefix: '371' },
    { code: 'LB', name: 'לבנון', prefix: '961' },
    { code: 'LS', name: 'לסוטו', prefix: '266' },
    { code: 'LR', name: 'ליבריה', prefix: '231' },
    { code: 'LY', name: 'לוב', prefix: '218' },
    { code: 'LI', name: 'ליכטנשטיין', prefix: '423' },
    { code: 'LT', name: 'ליטא', prefix: '370' },
    { code: 'LU', name: 'לוקסמבורג', prefix: '352' },
    { code: 'MO', name: 'מקאו', prefix: '853' },
    { code: 'MG', name: 'מדגסקר', prefix: '261' },
    { code: 'MW', name: 'מלאווי', prefix: '265' },
    { code: 'MY', name: 'מלזיה', prefix: '60' },
    { code: 'MV', name: 'האיים המלדיביים', prefix: '960' },
    { code: 'ML', name: 'מאלי', prefix: '223' },
    { code: 'MT', name: 'מלטה', prefix: '356' },
    { code: 'MH', name: 'איי מרשל', prefix: '692' },
    { code: 'MR', name: 'מאוריטניה', prefix: '222' },
    { code: 'MU', name: 'מאוריציוס', prefix: '230' },
    { code: 'MX', name: 'מקסיקו', prefix: '52' },
    { code: 'FM', name: 'מיקרונזיה', prefix: '691' },
    { code: 'MD', name: 'מולדובה', prefix: '373' },
    { code: 'MC', name: 'מונקו', prefix: '377' },
    { code: 'MN', name: 'מונגוליה', prefix: '976' },
    { code: 'ME', name: 'מונטנגרו', prefix: '382' },
    { code: 'MA', name: 'מרוקו', prefix: '212' },
    { code: 'MZ', name: 'מוזמביק', prefix: '258' },
    { code: 'MM', name: 'מיאנמר', prefix: '95' },
    { code: 'NA', name: 'נמיביה', prefix: '264' },
    { code: 'NR', name: 'נאורו', prefix: '674' },
    { code: 'NP', name: 'נפאל', prefix: '977' },
    { code: 'NL', name: 'הולנד', prefix: '31' },
    { code: 'NZ', name: 'ניו זילנד', prefix: '64' },
    { code: 'NI', name: 'ניקרגואה', prefix: '505' },
    { code: 'NE', name: 'ניז\'ר', prefix: '227' },
    { code: 'NG', name: 'ניגריה', prefix: '234' },
    { code: 'MK', name: 'מקדוניה הצפונית', prefix: '389' },
    { code: 'NO', name: 'נורווגיה', prefix: '47' },
    { code: 'OM', name: 'עומאן', prefix: '968' },
    { code: 'PK', name: 'פקיסטן', prefix: '92' },
    { code: 'PW', name: 'פלאו', prefix: '680' },
    { code: 'PA', name: 'פנמה', prefix: '507' },
    { code: 'PG', name: 'פפואה גינאה החדשה', prefix: '675' },
    { code: 'PY', name: 'פרגוואי', prefix: '595' },
    { code: 'PE', name: 'פרו', prefix: '51' },
    { code: 'PH', name: 'הפיליפינים', prefix: '63' },
    { code: 'PL', name: 'פולין', prefix: '48' },
    { code: 'PT', name: 'פורטוגל', prefix: '351' },
    { code: 'PR', name: 'פוארטו ריקו', prefix: '1787' },
    { code: 'QA', name: 'קטאר', prefix: '974' },
    { code: 'RO', name: 'רומניה', prefix: '40' },
    { code: 'RU', name: 'רוסיה', prefix: '7' },
    { code: 'RW', name: 'רואנדה', prefix: '250' },
    { code: 'KN', name: 'סנט קיטס ונוויס', prefix: '1869' },
    { code: 'LC', name: 'סנט לוסיה', prefix: '1758' },
    { code: 'VC', name: 'סנט וינסנט והגרנדינים', prefix: '1784' },
    { code: 'WS', name: 'סמואה', prefix: '685' },
    { code: 'SM', name: 'סן מרינו', prefix: '378' },
    { code: 'ST', name: 'סאו טומה ופרינסיפה', prefix: '239' },
    { code: 'SA', name: 'ערב הסעודית', prefix: '966' },
    { code: 'SN', name: 'סנגל', prefix: '221' },
    { code: 'RS', name: 'סרביה', prefix: '381' },
    { code: 'SC', name: 'סיישל', prefix: '248' },
    { code: 'SL', name: 'סיירה לאון', prefix: '232' },
    { code: 'SG', name: 'סינגפור', prefix: '65' },
    { code: 'SK', name: 'סלובקיה', prefix: '421' },
    { code: 'SI', name: 'סלובניה', prefix: '386' },
    { code: 'SB', name: 'איי שלמה', prefix: '677' },
    { code: 'SO', name: 'סומליה', prefix: '252' },
    { code: 'ZA', name: 'דרום אפריקה', prefix: '27' },
    { code: 'SS', name: 'דרום סודן', prefix: '211' },
    { code: 'ES', name: 'ספרד', prefix: '34' },
    { code: 'LK', name: 'סרי לנקה', prefix: '94' },
    { code: 'SD', name: 'סודן', prefix: '249' },
    { code: 'SR', name: 'סורינאם', prefix: '597' },
    { code: 'SE', name: 'שוודיה', prefix: '46' },
    { code: 'CH', name: 'שווייץ', prefix: '41' },
    { code: 'SY', name: 'סוריה', prefix: '963' },
    { code: 'TW', name: 'טייוואן', prefix: '886' },
    { code: 'TJ', name: 'טג\'יקיסטן', prefix: '992' },
    { code: 'TZ', name: 'טנזניה', prefix: '255' },
    { code: 'TH', name: 'תאילנד', prefix: '66' },
    { code: 'TL', name: 'טימור-לסטה', prefix: '670' },
    { code: 'TG', name: 'טוגו', prefix: '228' },
    { code: 'TO', name: 'טונגה', prefix: '676' },
    { code: 'TT', name: 'טרינידד וטובגו', prefix: '1868' },
    { code: 'TN', name: 'תוניסיה', prefix: '216' },
    { code: 'TR', name: 'טורקיה', prefix: '90' },
    { code: 'TM', name: 'טורקמניסטן', prefix: '993' },
    { code: 'TV', name: 'טובאלו', prefix: '688' },
    { code: 'UG', name: 'אוגנדה', prefix: '256' },
    { code: 'UA', name: 'אוקראינה', prefix: '380' },
    { code: 'AE', name: 'איחוד האמירויות הערביות', prefix: '971' },
    { code: 'GB', name: 'בריטניה', prefix: '44' },
    { code: 'UY', name: 'אורוגוואי', prefix: '598' },
    { code: 'UZ', name: 'אוזבקיסטן', prefix: '998' },
    { code: 'VU', name: 'ונואטו', prefix: '678' },
    { code: 'VA', name: 'הוותיקן', prefix: '379' },
    { code: 'VE', name: 'ונצואלה', prefix: '58' },
    { code: 'VN', name: 'וייטנאם', prefix: '84' },
    { code: 'YE', name: 'תימן', prefix: '967' },
    { code: 'ZM', name: 'זמביה', prefix: '260' },
    { code: 'ZW', name: 'זימבבואה', prefix: '263' },
    { code: 'OTHER', name: 'אחר', prefix: '' },
];

// Sort countries: Israel first, then alphabetically by Hebrew name
export const countries = [
    countriesUnsorted.find(c => c.code === 'IL'),
    ...countriesUnsorted
        .filter(c => c.code !== 'IL')
        .sort((a, b) => a.name.localeCompare(b.name, 'he'))
];

// Flag component that uses images from CDN
export const CountryFlag = ({ countryCode, className }) => {
    if (countryCode === 'OTHER') {
        return <span className={className}>🌍</span>;
    }
    return (
        <img
            src={getFlagUrl(countryCode)}
            alt={countryCode}
            className={className}
            onError={(e) => { e.target.style.display = 'none'; }}
        />
    );
};
